/* eslint-disable max-lines */
/* eslint-disable complexity */
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'dva'
import cloneDeep from 'lodash/cloneDeep'
import { Button, Dropdown, Form, Menu, message as $message, Popconfirm, Row, Space, Tooltip } from 'antd'
import CaretLeftOutlined from '@ant-design/icons/CaretLeftOutlined'
import DownOutlined from '@ant-design/icons/DownOutlined'
import UpOutlined from '@ant-design/icons/UpOutlined'
import CloseCircleFilled from '@ant-design/icons/CloseCircleFilled'
import MoreOutlined from '@ant-design/icons/MoreOutlined'
import CheckOutlined from '@ant-design/icons/CheckOutlined'
import ResizeObserver from 'rc-resize-observer'
import throttle from 'lodash/throttle'
import moment from 'moment'
import LayoutOutlined from '@ant-design/icons/LayoutOutlined'
import { getUUID } from 'gyl-common/utils/uuid'
import { DIS_AFTER_SALE_TIP_FIRST, ORDER_TIP_LAYOUT_FIRST } from '@/modules/globals/constants/iknow'
import { scorllPageAfterCollapseClose } from '@/components/AntdBaseTable/components/AffixV2/index'
import SortQuickSearch from '@/modules/globals/components/QueryFilter/components/SortQuickSearch'
import SortQuickSearchModal from '@/modules/globals/components/QueryFilter/components/SortQuickSearchModal'
import useClosePopWhenScroll from 'gyl-common/hooks/useClosePopWhenScroll'

import { jstLogSearch } from '@/utils/logger'
import { createAPI, promiseAPI } from '@/utils/modal'
import { isNumber } from '@/utils/utils'
import QuickSearchModal from './components/QuickSearchModal'
import isEmpty from 'lodash/isEmpty'
import classNames from 'classnames'
import debounce from 'lodash/debounce'
import isString from 'lodash/isString'
import getTextWidth from '@/utils/getTextWidth'
import styles from './index.less'
import { storage } from '@/hooks/useIknow'
import { LayoutWrap, calcColWith, useQueryLayout } from '@/hooks/useQueryLayout'
import useRecordOperation from '@/hooks/useRecordOperation'
import SearchFieldsConfigBtn from './components/ConfigDrawer/trigger'
import { getUnshowFieldNames, transConfigToRenderArr, transQuickSearchValueToQueryFormValue } from './helper'
import AnchorPanel from './components/AnchorPanel'
import { useGenConfigFields } from './components/ConfigDrawer/hooks'
import middleStyles from './styles.less'
import { IKnowDynamic } from '@/components/IKnow/IKnowDynamic'
import useHackPopScroll from './hooks/useHackPopScroll'
// import QuickSearchFilterList from './components/QuickSearchFilterList'

// 对比老版QueryFilter 新的样式省略了 num，showCol。

/**
 *  showScan: 是否需要下拉展开
 *  verticalSize: normal large(可以添加表单rules)
 *  disabled: 禁用按钮
 *  fontSize: 14px, 字体大小 这里主要因为订单页要12px
 */
const GUTTER = 8
const TIME_OUT_NUM = 2000
const maxQuickFilterLength = 50
const debounceTimer = 300
const WRAP_WIDTH = 900
const SELECT_NAME_MAX_LEN = 6
const THROLLE_TIME = 800
const SMALL_TIME_OUT = 30
// 展示展开收起的最小行数
const CONFIG_SHOW_SCAN_LINE_NUM = 3
const LINE_NUM = 3
export const newUserMoment = moment('2022-08-25')

const promiseSortQuickSearchModal = promiseAPI(SortQuickSearchModal)

const isEmptyObj = obj => {
    const objValues = Object.values(obj)
    for (let i = 0; i < objValues.length; i++) {
        const element = objValues[i]
        // isEmpty 判断了 布尔值 为 true ,这里处理下
        if (typeof element === 'boolean' || isNumber(element)) {
            return false
        }
        if (isString(element) && !!element) {
            return false
        }

        if (!isEmpty(element)) {
            // 订单状态要特殊处理
            if (element.orderStatus || element.questionTypes) {
                if (element.orderStatus?.length > 0 || element?.questionTypes?.length > 0) {
                    return false
                } else {
                    continue
                }
            }

            if (element?.startTime || element?.endTime) {
                return false
            }

            // 范围选择 leftValue rightValue 都要可以存(不考虑左边下拉的情况了)
            if (element?.leftValue || element?.rightValue) {
                return false
            }
        }
        if (element instanceof Array) {
            if (element.length > 0) {
                return false
            }
        }
    }
    return true
}

const ItemComponent = ({ item, form, initialValues, ...restProps }) => {
    const tips = typeof item.renderTips === 'function' ? item.renderTips({ form, initialValues }) : item.tips
    const tipsTrigger = item.tipsTrigger || 'hover'

    return (
        <Tooltip
            overlay={null}
            title={tips}
            trigger={tipsTrigger}
            overlayStyle={{ maxWidth: '225px', fontSize: '12px' }}
            color="rgba(0,0,0,0.7)"
        >
            <item.component
                form={form}
                name={item.name}
                {...restProps}
                {...item.props}
                {...(typeof item.renderProps === 'function' ? item.renderProps({ form, initialValues }) : {})}
            />
        </Tooltip>
    )
}

const ExtendAreaSearchContent = ({
    form,
    searchType,
    search,
    disabled,
    hideRest,
    reset,
    handleReset,
    collapseVisible,
    toggleCollapsed,
    toggleCollapse,
    memoCollapsed,
    setMemoCollapsed,
    renderExtraOperate
}) => {
    return (
        <Space data-todo="搜索/重置/配置 按钮区域" className={styles.right}>
            {collapseVisible ? (
                <Button
                    type="link"
                    className={classNames(styles.collapsed, styles.height28)}
                    onClick={() => {
                        if (memoCollapsed) {
                            setMemoCollapsed(!toggleCollapsed)
                        }
                        toggleCollapse()
                    }}
                >
                    {toggleCollapsed ? (
                        <>
                            展开&nbsp;
                            <DownOutlined />
                        </>
                    ) : (
                        <>
                            收起&nbsp;
                            <UpOutlined />
                        </>
                    )}
                </Button>
            ) : null}

            <Button type={searchType} onClick={search} disabled={disabled} className={styles.height28}>
                搜索
            </Button>

            {!hideRest && (
                <Button
                    className={styles.height28}
                    onClick={() => {
                        reset ? reset(form) : handleReset()
                    }}
                    disabled={disabled}
                >
                    重置
                </Button>
            )}
            {typeof renderExtraOperate === 'function' ? renderExtraOperate() : null}
        </Space>
    )
}

// 渲染筛选项
const renderFields = ({
    fields,
    form,
    initialValues,
    storagekeyPrefix,
    colNumPerLine,
    IKnowOptions,
    extendAreaSearch,
    extendArea,
    rowNum,
    direction,
    collapsed,
    toggleCollapse,
    toggleCollapsed,
    collapseVisible,
    searchType,
    search,
    disabled,
    hideRest,
    reset,
    handleReset,
    memoCollapsed,
    setMemoCollapsed,
    renderExtraOperate,
    querySearchType,
    renderQueryAddOrHide
}) => {
    const queryAddOrHide = renderQueryAddOrHide?.()
    if (colNumPerLine && queryAddOrHide && direction !== 'vertical') {
        // 水平布局时，新增/删除筛选条件的位置
        let queryAddOrHideIndex = fields.length
        let queryAddOrHideLayout
        if (collapsed) {
            let totalWidth = 0
            for (let index = 0; index < fields.length; index++) {
                const field = fields[index]
                const width = calcColWith(field.layout, colNumPerLine)
                totalWidth += width
                if (Math.round(totalWidth) >= 200) {
                    queryAddOrHideIndex = index
                    queryAddOrHideLayout = field.layout
                    break
                }
            }
        }

        fields.splice(queryAddOrHideIndex, 0, {
            queryAddOrHide: true,
            layout: queryAddOrHideLayout
        })
    }
    return (
        <Row
            gutter={GUTTER}
            className={classNames(styles.rowBox, {
                [styles.block]: direction === 'vertical'
            })}
        >
            {fields.map(item => {
                if (item.queryAddOrHide) {
                    return (
                        <LayoutWrap key="queryAddOrHide" field={item} colNumPerLine={colNumPerLine}>
                            {queryAddOrHide}
                        </LayoutWrap>
                    )
                }
                return (
                    <LayoutWrap
                        key={item.key || item.name}
                        field={item}
                        colNumPerLine={colNumPerLine}
                        querySearchType={querySearchType}
                    >
                        <IKnowDynamic options={IKnowOptions} name={item.name}>
                            <Form.Item
                                shouldUpdate={item.options && item.options.shouldUpdate ? () => true : () => false}
                                noStyle
                            >
                                {() => {
                                    if (
                                        typeof item.shouldRender === 'function' &&
                                        !item.shouldRender({ form, initialValues })
                                    ) {
                                        return null
                                    }
                                    return (
                                        <div key={item.name} style={item.style} className={styles.colUnit}>
                                            <Form.Item
                                                name={item.name}
                                                {...item.options}
                                                style={{
                                                    display: item.props && item.props.type === 'hidden' && 'none'
                                                }}
                                            >
                                                {item.tips || item.renderTips ? (
                                                    <ItemComponent
                                                        item={item}
                                                        form={form}
                                                        initialValues={initialValues}
                                                    />
                                                ) : (
                                                    <item.component
                                                        form={form}
                                                        name={item.name}
                                                        storagekey={`${storagekeyPrefix}_${item.name}`}
                                                        {...item.props}
                                                        {...(typeof item.renderProps === 'function'
                                                            ? item.renderProps({
                                                                  form,
                                                                  initialValues
                                                              })
                                                            : {})}
                                                    />
                                                )}
                                            </Form.Item>
                                        </div>
                                    )
                                }}
                            </Form.Item>
                        </IKnowDynamic>
                    </LayoutWrap>
                )
            })}
            {extendAreaSearch ? (
                <LayoutWrap extendArea={extendArea}>
                    <ExtendAreaSearchContent
                        form={form}
                        searchType={searchType}
                        search={search}
                        disabled={disabled}
                        hideRest={hideRest}
                        reset={reset}
                        handleReset={handleReset}
                        rowNum={rowNum}
                        collapseVisible={collapseVisible}
                        toggleCollapsed={toggleCollapsed}
                        toggleCollapse={toggleCollapse}
                        memoCollapsed={memoCollapsed}
                        setMemoCollapsed={setMemoCollapsed}
                        renderExtraOperate={renderExtraOperate}
                    />
                </LayoutWrap>
            ) : null}
        </Row>
    )
}

const BATCH_TOP = {
    name: 'backTop',
    label: '回到顶部',
    icon: 'icon-Top'
}

const QueryFilter = forwardRef(
    (
        {
            name,
            fields = [], // 必须是显示的 不然会对占位有影响
            initialValues = {},
            queryValues = {},
            className,
            classname,
            onValuesChange = () => {},
            onChange,
            showScan = true,
            direction,
            verticalSize = 'normal',
            searchType = 'primary',
            noCollapsedFields = [],
            defaultCollapsed = true,
            topNoCollapsedFields = [],
            firstComponent,
            reset,
            uid,
            memoCollapsed = false,
            disabled = false,
            hideRest = false,
            queryConfigKey = '',
            userCreated,
            queryConfigRedDotKey, // 常用筛选项设置 按钮上的小红点，不传则使用queryConfigKey
            groupFields, // 二位数组，一键排序时，需要固定靠在一起的筛选项
            extraQuery = {},
            buttonExtend,
            customVerticalHeader,
            storagekeyPrefix = location.pathname, // 如果需要缓存，缓存的key前缀
            configKey,
            config,
            setConfig,
            onClickQuickFilterCb,
            onCancelQuickFilterCb,
            extendAreaSearch = false, // 搜索按钮内嵌在搜索项中 选了该配置 底部的功能区不展示 根据实际情况使用 【目前使用场景：商品管理页面搜索】
            extendAreaCollapsedNum = 2, // 搜索按钮内嵌在搜索项中收起行数
            queryWidth, // 固定宽度 不跟随window动态变化
            IKnowOptions,
            whenHideDisplayNone,
            renderExtraOperate, // 搜索/重置 按钮后可能跟随 导出 等按钮
            registerMethods,
            unRegisterMethods,
            onCollapse,
            query = {},
            quickSearchExtraParameterFn, // 快捷查询保存的额外参数（例如排序等），返回保存数据的键值
            onLayoutChange,
            topClassName,
            middleClassName,
            onCollapseStatus,
            querySearchType,
            addSearchBtnStyle,
            hideShowQuickSort,
            ...restProps
        },
        ref
    ) => {
        // fields值会变化
        const [configFields, setConfigFields] = useState(fields)
        const [initConfig, setInitConfig] = useState({})
        const [tipVisible, setTipVisible] = useState(false)
        const { saveRecordStatus, getRecordStatus } = useRecordOperation({ name: DIS_AFTER_SALE_TIP_FIRST })
        const { saveRecordStatus: setOrderStatus, getRecordStatus: getOrderRecordStatus } = useRecordOperation({
            name: ORDER_TIP_LAYOUT_FIRST
        })

        const { isRecord: queryConfigRedDotIsRecord, saveRecordStatus: saveQueryConfigRedDotRecordStatus } =
            useRecordOperation({
                name: queryConfigRedDotKey || queryConfigKey,
                latitudeType: uid
            })

        const containerRef = useRef(null)
        const scrollerRef = useRef(null)
        const anchorRef = useRef(null)
        const quickResAreaRef = useRef(null)
        const $quickSearch = useRef(null)
        const isNewUser = useMemo(() => {
            return userCreated && moment(userCreated).isAfter(newUserMoment)
        }, [userCreated])

        // 生成默认的用户配置
        let memoData = useGenConfigFields(fields, null, true)
        useEffect(() => {
            if (Object.prototype.toString.call(initConfig) === '[object Object]' && Object.keys(initConfig).length) {
                setConfigFields(transConfigToRenderArr(fields, initConfig, whenHideDisplayNone, queryConfigKey))
            }
            if (Object.prototype.toString.call(initConfig) === '[object Object]' && !Object.keys(initConfig).length) {
                setConfigFields(transConfigToRenderArr(fields, initConfig, whenHideDisplayNone, queryConfigKey))
            }
            if (initConfig === null) {
                // 用户从未配置过该页面查询条件
                if (memoData.config) {
                    setConfigFields(
                        transConfigToRenderArr(fields, memoData.config, whenHideDisplayNone, queryConfigKey)
                    )
                }
            }
            // 目前 isNewUser， whenHideDisplayNone 是定量 memoData.config是拿初始化配置值 initConfig是用户保存的配置，原代码逻辑是在用户初始化抽屉后或者点击保存后，进行调用更新的。所以基本上前面的字段基本上是进入页面后不会再进行更新的
            // fields这个字段本来以为不会更新的，但是逻辑显示有可能被外部更新
        }, [isNewUser, fields, disabled, initConfig, memoData.config, whenHideDisplayNone, queryConfigKey])

        const onTipStatus = () => {
            if (!getRecordStatus() && (name === 'afterSalesQuery' || name === 'distributorAfterSalesQuery')) {
                setTipVisible(true)
                saveRecordStatus(true)
                setTimeout(() => {
                    setTipVisible(false)
                }, TIME_OUT_NUM)
            }
            if (!getOrderRecordStatus() && name === 'supplierManageQuery') {
                setTipVisible(true)
                setOrderStatus(true)
                setTimeout(() => {
                    setTipVisible(false)
                }, TIME_OUT_NUM)
            }
        }

        const isVertical = direction === 'vertical'

        useEffect(() => {
            if (isVertical) {
                onTipStatus()
            }
        }, [isVertical])

        // 监听disabled和fields变化，重新更新fields
        // useEffect(() => {
        //     setConfigFields(fields)
        // }, [disabled, fields])

        const tableNameAndId = `${name}_queryFilter`
        const [collapsed, setCollapsed] = useState(() => {
            if (memoCollapsed) {
                // 收否为非 defaultCollapsed
                const arr = storage.get(`${tableNameAndId}_collapsed`) || []
                if (arr.indexOf(uid) > -1) {
                    return !defaultCollapsed
                } else {
                    return defaultCollapsed
                }
            }

            return defaultCollapsed
        })

        // 如果是搜索按钮内嵌, 则需配置 [collapsedNum?: number 指定收起行数、defaultCollapsed?: boolean 默认折叠状态 ]
        const layoutConfig = extendAreaSearch
            ? { collapsedNum: extendAreaCollapsedNum, defaultCollapsed: collapsed, queryWidth, direction }
            : { queryWidth, direction }

        const {
            fields: layoutFields,
            colNumPerLine,
            rowNum,
            extendArea,
            toggleCollapse,
            collapseVisible,
            collapsed: toggleCollapsed
        } = useQueryLayout(configFields, layoutConfig)

        const [form] = Form.useForm()

        useImperativeHandle(
            ref,
            () => ({
                ...form,
                handleReset,
                setQuickSearch,
                clearCheckedFilter: $quickSearch.current?.clearCheckedFilter,
                search
            }),
            [form]
        )

        const search = async () => {
            let values = null

            try {
                values = await form.validateFields()
            } catch (e) {
                console.error('validate', e)
                const { errorFields } = e
                const firstName = errorFields && errorFields[0] && errorFields[0].name
                scrollTo(firstName)
                $message.error('请填写正确搜索内容')
                return Promise.reject(new Error('操作失败'))
            }

            jstLogSearch({
                args: values
            })

            onChange(values, 'search')
        }

        const setQuickSearch = values => {
            form.resetFields()
            form.setFieldsValue(values)
            onChange(values, 'search')
        }

        const handleReset = () => {
            form.resetFields()

            onChange(initialValues, 'reset')
        }

        useEffect(() => {
            if (Object.keys(queryValues).length) {
                form.setFieldsValue({ ...initialValues, ...queryValues })
            }
        }, [queryValues])

        // 回车搜索
        useEffect(() => {
            setTimeout(() => {
                const $el = document.getElementById(tableNameAndId)

                if (!$el) {
                    return
                }

                $el.onkeyup = debounce(event => {
                    const noEnterEvent = !event?.target?.dataset?.keyenterevent
                    if (noEnterEvent && (event.key === 'Enter' || event.code === 'Enter')) {
                        search()
                    }
                }, debounceTimer)
            })
        }, [name, search])

        const setMemoCollapsed = bool => {
            // 只记录 true 收起
            let arr = storage.get(`${tableNameAndId}_collapsed`) || []
            const index = arr.indexOf(uid)
            if (index > -1 && !bool) {
                arr.splice(index, 1)
            }

            if (index === -1 && bool) {
                arr.push(uid)
            }

            storage.set(`${tableNameAndId}_collapsed`, arr)
        }

        // 渲染原先右侧空白
        const renderButtonExtend = (...args) => {
            const renderOutButtonExtend = (...args) => {
                if (typeof buttonExtend === 'function') {
                    return buttonExtend(...args)
                }
                if (buttonExtend) {
                    return buttonExtend
                }
                return null
            }

            return <>{renderOutButtonExtend(...args)}</>
        }

        const renderQueryAddOrHide = () => {
            if (!queryConfigKey) {
                return null
            }
            return (
                <div
                    style={{
                        display: 'flex',
                        height: 28,
                        marginBottom: 6,
                        alignItems: 'center',
                        position: 'relative',
                        ...addSearchBtnStyle
                    }}
                >
                    <SearchFieldsConfigBtn
                        simple
                        registerMethods={registerMethods}
                        unRegisterMethods={unRegisterMethods}
                        queryConfigKey={queryConfigKey}
                        fields={fields}
                        redDot={!queryConfigRedDotIsRecord}
                        onClick={() => saveQueryConfigRedDotRecordStatus(true)}
                        btnProps={{
                            style: { alignSelf: 'center', marginRight: '8px' }
                        }}
                        groupFields={groupFields}
                        isNewUser={isNewUser}
                        initCallback={config => {
                            setConfigFields(transConfigToRenderArr(fields, config, whenHideDisplayNone, queryConfigKey))
                            setInitConfig(config)
                        }}
                        onCollapse={() => {
                            if (memoCollapsed) {
                                setMemoCollapsed(true)
                                setCollapsed(true)
                            }
                        }}
                        onSaveCallback={data => {
                            setConfigFields(transConfigToRenderArr(fields, data, whenHideDisplayNone, queryConfigKey))
                            // configKey && setConfig && setConfig(configKey, data)
                            setInitConfig(data)
                            const unshowFieldNames = getUnshowFieldNames(data)
                            form.resetFields(unshowFieldNames)
                        }}
                        hideShowQuickSort={hideShowQuickSort}
                    >
                        添加/隐藏搜索条件
                    </SearchFieldsConfigBtn>
                </div>
            )
        }

        const filtersRender = node => {
            if (!isVertical) {
                return
            }

            if (!quickResAreaRef.current) {
                return null
            }

            return ReactDOM.createPortal(node, quickResAreaRef.current)
        }

        const filterCollapsed = showScan && !extendAreaSearch ? collapsed : false

        useClosePopWhenScroll({
            disabled: !isVertical,
            container() {
                return scrollerRef.current
            }
        })

        useHackPopScroll({
            disabled: !isVertical,
            scrollerRef,
            containerRef
        })

        const anchorList = useMemo(() => {
            const allList = (layoutFields || [])
                .filter(v => v.show !== false)
                .map(v => ({
                    icon: v.icon,
                    name: v.name,
                    label: v.labelName
                }))

            return [BATCH_TOP].concat(allList)
        }, [layoutFields])

        // hack：已经在底部，容器滚动导致高度变化，触发scroll
        const mouseOverRef = useRef(false)

        const handleScroll = () => {
            if (!isVertical) {
                return
            }

            if (!mouseOverRef.current) {
                return
            }

            anchorRef.current?.show()
        }

        const handleContainerResize = () => {
            if (!isVertical) {
                return
            }

            anchorRef.current?.updatePosition()
        }

        const timerMapRef = useRef({})

        const scrollToViewCenter = el => {
            const { top, height } = el.getBoundingClientRect()
            // 元素的中心高度
            const elCenter = top + height / 2
            // 窗口的中心高度
            const center = scrollerRef.current.offsetHeight / 2

            scrollerRef.current.scrollTo({
                top: scrollerRef.current.scrollTop - (center - elCenter) - 100,
                behavior: 'smooth'
            })
        }
        const handleAnchorItemClick = target => {
            // 返回顶部
            if (target.name === 'backTop') {
                if (scrollerRef.current) {
                    scrollerRef.current.scrollTop = 0
                }
            } else {
                form?.scrollToField(target.name)
                const targetId = `${name}_${target.name}`
                // 元素滚动到中间
                scrollToViewCenter(document.getElementById(targetId))

                const targetEl = document.querySelector(`#${targetId}`)?.closest('.ant-form-item')

                if (!targetEl) {
                    return
                }

                const oClassName = styles.highlightSupplier

                if (!targetEl.classList.contains(oClassName)) {
                    targetEl.classList.add(oClassName)
                }

                if (timerMapRef.current[targetId]) {
                    clearTimeout(timerMapRef.current[targetId])
                }
                timerMapRef.current[targetId] = setTimeout(() => {
                    targetEl.classList.remove(oClassName)
                }, TIME_OUT_NUM)
            }
        }

        const isShowScan = useMemo(() => {
            return showScan && rowNum >= CONFIG_SHOW_SCAN_LINE_NUM
        }, [showScan, rowNum])

        const handleValuesChange = (...props) => {
            $quickSearch.current?.clearCheckedFilter?.()
            onValuesChange(...props)
        }

        return (
            <ResizeObserver onResize={handleContainerResize}>
                <div
                    id={tableNameAndId}
                    ref={containerRef}
                    className={classNames(middleStyles.containerWrap, {
                        [styles.fixedSide]: isVertical,
                        [middleStyles.hasVertical]: isVertical
                    })}
                >
                    {isVertical ? (
                        <div className={styles.header}>
                            <div className={styles.headerTitle}>筛选区</div>
                            {customVerticalHeader || (
                                <Tooltip
                                    visible={tipVisible}
                                    placement="top"
                                    title="点击这里，可以随时切换上下布局或左右布局哦！"
                                >
                                    <Button type="link" onClick={onLayoutChange} data-log-text="切换到上下布局">
                                        <LayoutOutlined style={{ marginRight: '3px', fontSize: '13px' }} />
                                        <span style={{ fontSize: '13px' }}>切换布局</span>
                                    </Button>
                                </Tooltip>
                            )}
                            <a
                                className={styles.headerExtra}
                                onClick={() => {
                                    anchorRef.current?.show()
                                    onCollapse()
                                }}
                            >
                                收起 <CaretLeftOutlined />
                            </a>
                        </div>
                    ) : null}

                    <div
                        ref={scrollerRef}
                        className={classNames({
                            [styles.scroller]: isVertical,
                            [middleStyles.sizeSmall]: isVertical
                        })}
                        onMouseOver={() => {
                            mouseOverRef.current = true
                        }}
                        onMouseOut={() => {
                            mouseOverRef.current = false
                        }}
                        onScroll={handleScroll}
                    >
                        <Form
                            name={name}
                            form={form}
                            scrollToFirstError
                            initialValues={initialValues}
                            className={classNames(className)}
                            onValuesChange={handleValuesChange}
                            // size="default"
                            {...restProps}
                        >
                            {topNoCollapsedFields?.length > 0 ? (
                                <div
                                    className={classNames(
                                        styles.queryFilter,
                                        styles.topNoCollapsedStyles,
                                        {
                                            [styles.normalVerticalSize]: verticalSize === 'normal',
                                            [styles.largeVerticalSize]: verticalSize === 'large'
                                        },
                                        classname,
                                        topClassName
                                    )}
                                >
                                    {firstComponent}
                                    {/* TODO 顶部不折叠的单元 可设置独享宽度 */}
                                    {renderFields({
                                        fields: topNoCollapsedFields,
                                        form,
                                        initialValues,
                                        storagekeyPrefix,
                                        extendArea,
                                        rowNum,
                                        direction,
                                        toggleCollapse,
                                        extendAreaSearch: false, // 顶部字段不需要额外的内嵌搜索按钮
                                        collapseVisible,
                                        toggleCollapsed,
                                        searchType,
                                        search,
                                        disabled,
                                        hideRest,
                                        reset,
                                        handleReset,
                                        memoCollapsed,
                                        setMemoCollapsed
                                    })}
                                </div>
                            ) : null}

                            <div ref={quickResAreaRef} />

                            <div
                                className={classNames(
                                    styles.queryFilter,
                                    styles.middleFilterStyle,
                                    {
                                        [styles.normalVerticalSize]: verticalSize === 'normal',
                                        [styles.largeVerticalSize]: verticalSize === 'large'
                                    },
                                    classname,
                                    middleClassName
                                )}
                            >
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <div
                                        className={classNames({
                                            [styles.filterCollapsed]: isVertical ? false : filterCollapsed
                                        })}
                                    >
                                        {renderFields({
                                            fields: layoutFields,
                                            form,
                                            initialValues,
                                            storagekeyPrefix,
                                            colNumPerLine,
                                            extendArea,
                                            rowNum,
                                            direction,
                                            collapsed,
                                            toggleCollapse,
                                            extendAreaSearch,
                                            collapseVisible,
                                            toggleCollapsed,
                                            searchType,
                                            search,
                                            disabled,
                                            hideRest,
                                            reset,
                                            handleReset,
                                            memoCollapsed,
                                            setMemoCollapsed,
                                            IKnowOptions,
                                            renderExtraOperate,
                                            querySearchType,
                                            renderQueryAddOrHide
                                        })}
                                    </div>

                                    {/* 操作按钮  */}
                                    {!isVertical && !extendAreaSearch ? (
                                        <div
                                            data-todo="底部操作Bar"
                                            className={classNames({
                                                [styles.operation]: true,
                                                [styles.showScan]: showScan,
                                                [styles.hideRest]: hideRest
                                            })}
                                        >
                                            {configKey && (
                                                <QuickSearchQueryFilterInner
                                                    ref={$quickSearch}
                                                    form={form}
                                                    quickSearchExtraParameterFn={quickSearchExtraParameterFn}
                                                    extraQuery={extraQuery}
                                                    configKey={configKey}
                                                    config={config}
                                                    query={query}
                                                    setConfig={setConfig}
                                                    onClickQuickFilterCb={onClickQuickFilterCb}
                                                    onCancelQuickFilterCb={onCancelQuickFilterCb}
                                                    setQuickSearch={setQuickSearch}
                                                />
                                            )}
                                            {/* TODO 渲染打单子应用扩展按钮 （可以整合） */}

                                            {renderButtonExtend(collapsed)}
                                            <Space data-todo="搜索/重置 按钮区域" className={styles.right}>
                                                {isShowScan ? (
                                                    <Button
                                                        type="link"
                                                        className={classNames(styles.collapsed, styles.height28)}
                                                        onClick={() => {
                                                            if (memoCollapsed) {
                                                                setMemoCollapsed(!collapsed)
                                                            }
                                                            if (!collapsed) {
                                                                scorllPageAfterCollapseClose()
                                                            }
                                                            setCollapsed(!collapsed)
                                                            onCollapseStatus && onCollapseStatus(!collapsed)
                                                        }}
                                                    >
                                                        {collapsed ? (
                                                            <>
                                                                展开&nbsp;
                                                                <DownOutlined />
                                                            </>
                                                        ) : (
                                                            <>
                                                                收起&nbsp;
                                                                <UpOutlined />
                                                            </>
                                                        )}
                                                    </Button>
                                                ) : null}

                                                <Button
                                                    type={searchType}
                                                    onClick={search}
                                                    disabled={disabled}
                                                    className={styles.height28}
                                                >
                                                    搜索
                                                </Button>

                                                {!hideRest && (
                                                    <Button
                                                        className={styles.height28}
                                                        onClick={() => {
                                                            $quickSearch.current?.clearCheckedFilter?.()
                                                            reset ? reset(form) : handleReset()
                                                        }}
                                                        disabled={disabled}
                                                    >
                                                        重置
                                                    </Button>
                                                )}
                                            </Space>
                                        </div>
                                    ) : null}
                                </Space>
                            </div>
                            {noCollapsedFields?.length > 0 ? (
                                <div
                                    className={classNames(
                                        styles.queryFilter,
                                        {
                                            [styles.normalVerticalSize]: verticalSize === 'normal',
                                            [styles.largeVerticalSize]: verticalSize === 'large'
                                        },
                                        classname
                                    )}
                                >
                                    {renderFields({
                                        fields: noCollapsedFields,
                                        form,
                                        initialValues,
                                        storagekeyPrefix
                                    })}
                                </div>
                            ) : null}
                        </Form>
                    </div>
                    {isVertical ? (
                        <div className={styles.footer}>
                            <div className={styles.actions}>
                                {queryConfigKey && (
                                    <SearchFieldsConfigBtn
                                        registerMethods={registerMethods}
                                        unRegisterMethods={unRegisterMethods}
                                        simple
                                        queryConfigKey={queryConfigKey}
                                        fields={fields}
                                        redDot={!queryConfigRedDotIsRecord}
                                        onClick={() => saveQueryConfigRedDotRecordStatus(true)}
                                        btnProps={{
                                            style: { alignSelf: 'center', marginRight: '8px' }
                                        }}
                                        groupFields={groupFields}
                                        isNewUser={isNewUser}
                                        initCallback={config => {
                                            setConfigFields(
                                                transConfigToRenderArr(
                                                    fields,
                                                    config,
                                                    whenHideDisplayNone,
                                                    queryConfigKey
                                                )
                                            )
                                            setInitConfig(config)
                                        }}
                                        onCollapse={() => {
                                            if (memoCollapsed) {
                                                setMemoCollapsed(true)
                                            }
                                            setCollapsed(true)
                                        }}
                                        isVertical={isVertical}
                                        onSaveCallback={data => {
                                            setConfigFields(
                                                transConfigToRenderArr(
                                                    fields,
                                                    data,
                                                    whenHideDisplayNone,
                                                    queryConfigKey
                                                )
                                            )
                                            // configKey && setConfig && setConfig(configKey, data)
                                            setInitConfig(data)
                                            const unshowFieldNames = getUnshowFieldNames(data)
                                            form.resetFields(unshowFieldNames)
                                        }}
                                    >
                                        添加/隐藏搜索条件
                                    </SearchFieldsConfigBtn>
                                )}
                                {configKey && (
                                    <QuickSearchQueryFilterInner
                                        ref={$quickSearch}
                                        simple
                                        form={form}
                                        extraQuery={extraQuery}
                                        configKey={configKey}
                                        config={config}
                                        query={query}
                                        filtersRender={filtersRender}
                                        setConfig={setConfig}
                                        onClickQuickFilterCb={onClickQuickFilterCb}
                                        onCancelQuickFilterCb={onCancelQuickFilterCb}
                                        setQuickSearch={setQuickSearch}
                                    />
                                )}
                            </div>
                            <div className={styles.btns}>
                                <Button
                                    type={searchType}
                                    onClick={search}
                                    disabled={disabled}
                                    className={styles.height28}
                                >
                                    搜索
                                </Button>
                                {!hideRest && (
                                    <Button
                                        className={styles.height28}
                                        onClick={() => {
                                            $quickSearch.current?.clearCheckedFilter?.()
                                            reset ? reset(form) : handleReset()
                                        }}
                                        disabled={disabled}
                                    >
                                        重置
                                    </Button>
                                )}
                            </div>
                        </div>
                    ) : null}

                    {isVertical ? (
                        <AnchorPanel
                            ref={anchorRef}
                            syncEl={() => containerRef.current}
                            anchorList={anchorList}
                            onItemClick={handleAnchorItemClick}
                        />
                    ) : null}
                </div>
            </ResizeObserver>
        )
    }
)

// 产品需求部分放开
// QUICK_SEARCH 以QS 开头
const WHITE_LIST = ['']

const QuickQueryItem = ({ className, checked, item, index, handelDel, handelClickFilter }) => {
    return (
        <>
            <div
                className={classNames(
                    styles.noChecked,
                    {
                        [styles.checked]: checked
                    },
                    className
                )}
                data-log-text={`快捷查询_${item.displaySelectName || item.selectName}`}
                title={item.selectName}
                onClick={e => {
                    handelClickFilter(item, index, checked)
                    e.stopPropagation()
                }}
            >
                <CheckOutlined className={styles.gou} />

                <span>{item.displaySelectName || item.selectName}</span>
            </div>
            {!checked && (
                <Popconfirm
                    title={<div style={{ width: 100 }}>是否删除?</div>}
                    okText="是"
                    cancelText="否"
                    onConfirm={() => {
                        handelDel(index)
                    }}
                >
                    <div
                        className={styles.close}
                        onClick={e => {
                            e.stopPropagation()
                        }}
                    >
                        <CloseCircleFilled />
                    </div>
                </Popconfirm>
            )}
        </>
    )
}

const QuickSearchQueryFilterInner = forwardRef((props, ref) => {
    const {
        configKey,
        config,
        setConfig,
        onClickQuickFilterCb,
        onCancelQuickFilterCb,
        form,
        extraQuery,
        setQuickSearch,
        simple,
        filtersRender,
        quickSearchExtraParameterFn,
        query = {}
    } = props

    const [checkedFilter, setCheckedFilter] = useState()
    const [expand, setExpand] = useState(false)

    const [wrapWidth, setWrapWidth] = useState(WRAP_WIDTH)

    //  暂时没有要求，代码我先留在这里，有需要再加
    // eslint-disable-next-line no-unused-vars
    const hasQuickSearchSetting = WHITE_LIST && WHITE_LIST.includes(configKey)

    const { filters = [], ...restConfigs } = config || {}

    const onUpdateConfig = (newFilter, override) => {
        return setConfig(configKey, { ...restConfigs, filters: newFilter }, override)
    }

    const clearCheckedFilter = () => {
        setCheckedFilter(null)
    }

    const handelConfigAdd = ({ selectName, fields }) => {
        onUpdateConfig([{ selectName, fields }, ...filters])
    }

    const handelDel = index => {
        const newFilter = [...filters]
        newFilter.splice(index, 1)
        const checkedIndex = (checkedFilter || '').split('-')[1]
        if (isNumber(Number(checkedIndex)) && Number(checkedIndex) > index) {
            setCheckedFilter(pre => {
                return `${pre.split('-')[0]}-${Number(checkedIndex) - 1}`
            })
        }
        // 返回值是删除的那个
        onUpdateConfig(newFilter)
    }

    const handelClickFilter = (item, index, checked) => {
        if (!checked) {
            setCheckedFilter(`${item.selectName}-${index}`)
            setQuickSearch?.(transQuickSearchValueToQueryFormValue(item.fields))
            onClickQuickFilterCb?.(item, index)
        } else {
            const itemFields = cloneDeep(item.fields)
            const selectFields = { ...itemFields }
            Object.keys(selectFields).forEach(v => {
                if (typeof itemFields[v] === 'object') {
                    if (
                        Object.prototype.toString.call(itemFields[v]) === '[object Object]' &&
                        itemFields[v]?.rightValue
                    ) {
                        selectFields[v].rightValue = undefined
                    }
                    if (Array.isArray(itemFields[v]) && itemFields[v].length > 0) {
                        selectFields[v] = []
                    }
                } else if (itemFields[v]) {
                    selectFields[v] = undefined
                }
            })
            setQuickSearch?.(selectFields)
            setCheckedFilter('')
            onClickQuickFilterCb?.(item, index)
            onCancelQuickFilterCb?.(form)
        }
    }

    // 快捷查询保存
    const showQuickSearchModal = async () => {
        const quickFilterLength = filters?.length
        if (quickFilterLength >= maxQuickFilterLength) {
            $message.warning(`最多可添加${maxQuickFilterLength}个快捷查询条件，请您删除不需要的快捷查询条件`)
            return
        }

        const formValues = await form.getFieldsValue()
        const quickSearchExtraParameter = quickSearchExtraParameterFn && quickSearchExtraParameterFn()
        const values = {
            ...formValues,
            ...extraQuery,
            ...quickSearchExtraParameter
        }

        if (isEmptyObj(values)) {
            $message.warning(`请先填写筛选项`)
            return
        }
        clearCheckedFilter?.()
        createAPI(QuickSearchModal, {
            onOk: selectName => {
                console.log('selectName: ', selectName, values)
                setCheckedFilter(`${selectName}-0`)
                handelConfigAdd({
                    selectName,
                    fields: values
                })
            }
        })
    }

    // 快捷查询配置排序
    const sortQuickSearchConfig = async () => {
        const { data } = await promiseSortQuickSearchModal({
            quickSearchOptions: filters
        })

        onUpdateConfig(data.list, true)
        $message.success('保存成功')
    }

    const data = useMemo(() => {
        if (simple) {
            const { tileData, collapsedData, allData } = filters.reduce(
                (t, c) => {
                    const addEllipsis = c.selectName.length > SELECT_NAME_MAX_LEN
                    const briefName = addEllipsis ? `${c.selectName.slice(0, SELECT_NAME_MAX_LEN)}` : c.selectName
                    const displaySelectName = addEllipsis ? `${briefName}...` : briefName

                    const obj = {
                        ...c,
                        displaySelectName,
                        uuid: getUUID()
                    }

                    t.allData.push(obj)

                    return t
                },
                {
                    allData: [],
                    tileData: [],
                    collapsedData: []
                }
            )

            return {
                allData,
                tileData,
                collapsedData
            }
        }

        let tileData = []
        let collapsedData = []
        let totalWidth = 200 // 另存为快捷查询130 + 更多30 + 更多距离收起的距离40

        if (filters?.length > 1) {
            totalWidth += 85 // 快捷查询排序
        }
        // 获取快捷查询展示列表 padding + border + margin
        const ITEM_WITHOUT_LETTER_WIDTH = 8 * 2 + 0 + 4 * 2
        if (Array.isArray(filters) && filters.length) {
            // 138+30+40
            filters.forEach(item => {
                const itemWidth = getTextWidth({ text: item.selectName, font: '13px' }) + ITEM_WITHOUT_LETTER_WIDTH

                totalWidth += itemWidth
                if (totalWidth < wrapWidth) {
                    tileData.push(item)
                } else {
                    collapsedData.push(item)
                }
            })
        }

        return {
            tileData,
            collapsedData
        }
    }, [filters, wrapWidth, simple])

    const handleExpand = () => {
        setExpand(prev => !prev)
    }

    const handleResize = throttle(({ width }) => {
        if (width <= 0) {
            return
        }

        setWrapWidth(width)
    }, THROLLE_TIME)

    useImperativeHandle(ref, () => ({ clearCheckedFilter }), [])

    const helperElRef = useRef(null)

    const [vData, setVData] = useState({
        hasMore: false,
        list: []
    })

    useEffect(() => {
        if (!simple) {
            return
        }

        // TODO 先这样吧
        setTimeout(() => {
            const nodes = Array.from(helperElRef.current?.querySelectorAll(`.j-item`) || [])

            const res = nodes.reduce(
                (t, c) => {
                    const rect = {
                        top: c.offsetTop,
                        width: c.offsetWidth
                    }

                    const last = t.info[t.info.length - 1]
                    const line = last && last.top === rect.top ? t.lineNum : ++t.lineNum

                    t.info.push({
                        ...rect,
                        line
                    })

                    return t
                },
                {
                    lineNum: 0,
                    info: []
                }
            )

            // hack：最后一个是触发器，且单占一行（最后一个和倒数第二个不在一行）
            if (res.lineNum === LINE_NUM && res.info[res.info.length - 1] !== res.info[res.info.length - 2]) {
                // 将倒数第二个的行数修改为3
                res.info[res.info.length - 2].line = LINE_NUM
            }

            const newData = data.allData?.filter((v, k) => {
                const rect = res.info[data.allData.length > 1 ? k + 1 : k]

                return !(rect && rect.line > 2 && !expand)
            })

            setVData({
                hasMore: res.lineNum > 2,
                list: (newData || []).map(v => ({
                    ...v,
                    uuid: getUUID()
                }))
            })
        }, SMALL_TIME_OUT)
    }, [data.allData, expand, simple])

    if (simple) {
        return (
            <>
                <a onClick={showQuickSearchModal}>另存为快捷查询</a>
                <div style={{ width: '234px', position: 'absolute', left: '-99999px' }} ref={helperElRef}>
                    <div className={classNames(styles.quickSection)}>
                        {data.allData.length > 1 ? (
                            <a
                                className="j-item"
                                style={{ lineHeight: '24px', marginRight: '6px', marginBottom: '6px' }}
                            >
                                筛选项排序
                            </a>
                        ) : null}
                        {data.allData.map((item, index) => {
                            const checked = checkedFilter === `${item.selectName}-${index}`
                            return (
                                // eslint-disable-next-line react/no-array-index-key
                                <div
                                    className={classNames(styles.container, styles.hasSmall, 'j-item')}
                                    key={`${item.selectName}-${item.uuid}`}
                                >
                                    <QuickQueryItem
                                        checked={checked}
                                        item={item}
                                        index={index}
                                        handelDel={handelDel}
                                        handelClickFilter={handelClickFilter}
                                    />
                                </div>
                            )
                        })}
                        <div className={classNames(styles.quickExpand, 'j-item')} style={{ width: '12px' }} />
                    </div>
                </div>
                {filtersRender(
                    vData.list.length ? (
                        <div style={{ marginRight: '-6px' }}>
                            <ResizeObserver onResize={handleResize}>
                                <div className={classNames(styles.quickSection)}>
                                    {vData.list.length > 1 ? (
                                        <a
                                            className="j-item"
                                            style={{ lineHeight: '24px', marginRight: '6px', marginBottom: '6px' }}
                                            onClick={sortQuickSearchConfig}
                                        >
                                            筛选项排序
                                        </a>
                                    ) : null}

                                    {vData.list.map((item, index) => {
                                        const checked = checkedFilter === `${item.selectName}-${index}`
                                        return (
                                            // eslint-disable-next-line react/no-array-index-key
                                            <div
                                                className={classNames(styles.container, styles.hasSmall)}
                                                key={`${item.selectName}-${item.uuid}`}
                                            >
                                                <QuickQueryItem
                                                    checked={checked}
                                                    item={item}
                                                    index={index}
                                                    handelDel={handelDel}
                                                    handelClickFilter={handelClickFilter}
                                                />
                                            </div>
                                        )
                                    })}

                                    {vData.hasMore ? (
                                        <>
                                            <div />
                                            <div
                                                className={classNames(styles.quickExpand, styles.fixedExpand)}
                                                onClick={handleExpand}
                                            >
                                                {expand ? (
                                                    <UpOutlined className={styles.quickExpandIcon} />
                                                ) : (
                                                    <DownOutlined className={styles.quickExpandIcon} />
                                                )}
                                            </div>
                                        </>
                                    ) : null}
                                    <div className={styles.hackLine} />
                                </div>
                            </ResizeObserver>
                        </div>
                    ) : null
                )}
            </>
        )
    }

    const menu = (
        <Menu
            style={{
                maxHeight: 300,
                overflowY: 'auto'
            }}
        >
            {data.collapsedData.map((item, index) => {
                const currentIndex = index + data.tileData.length
                const checked = checkedFilter === `${item.selectName}-${currentIndex}`
                return (
                    <Menu.Item
                        className={classNames(styles.menu)}
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${item.selectName}-${currentIndex}`}
                    >
                        <QuickQueryItem
                            checked={checked}
                            item={item}
                            index={currentIndex}
                            handelDel={handelDel}
                            handelClickFilter={handelClickFilter}
                        />
                    </Menu.Item>
                )
            })}
        </Menu>
    )

    return (
        <ResizeObserver onResize={handleResize}>
            <Space
                size="small"
                style={{
                    width: '100%'
                }}
                wrap
            >
                <Button className={styles.height28} onClick={showQuickSearchModal}>
                    另存为快捷查询
                </Button>

                {filters?.length > 1 ? <SortQuickSearch onClick={sortQuickSearchConfig} /> : null}

                {data.tileData.map((item, index) => {
                    const checked = checkedFilter === `${item.selectName}-${index}`
                    return (
                        // eslint-disable-next-line react/no-array-index-key
                        <div className={styles.container} key={`${item.selectName}-${index}`}>
                            <QuickQueryItem
                                checked={checked}
                                item={item}
                                index={index}
                                handelDel={handelDel}
                                handelClickFilter={handelClickFilter}
                            />
                        </div>
                    )
                })}

                {Array.isArray(data.collapsedData) && data.collapsedData.length ? (
                    <Dropdown overlay={menu} trigger={['click']}>
                        <span onClick={e => e.preventDefault()}>
                            <div className={styles.more}>
                                <MoreOutlined />
                            </div>
                        </span>
                    </Dropdown>
                ) : null}
            </Space>
        </ResizeObserver>
    )
})

const DEFAULT_CONFIG = {}

const mapStateToProps = ({ user: { config, currentUser } }, ownProps) => {
    return {
        config: (config && ownProps.configKey && config[ownProps.configKey]) || DEFAULT_CONFIG,
        userCreated: currentUser?.checkInTime
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setConfig(configKey, configValue) {
            return dispatch({
                type: 'user/addConfig',
                payload: {
                    configKey,
                    configValue
                }
            })
        }
    }
}

export const QuickSearchQueryFilter = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    QueryFilter
)

export default QueryFilter
